export default {
	craftsmanTasks: {
		create: 'Create craftsman task',
		createFromReport: 'Create from report',
		subject_type: 'Type',
		craftsman: 'Craftsman',
		craftsmanTaskType: 'Craftsman Task Type',
		scheduling: 'Scheduling',
		process: 'Process',
		building: {
			name: '@:entity.building.name',
		},
		unit: {
			name: '@:entity.unit.name',
		},
		team: {
			last_name: '@:entity.team.name',
		},
		assignedOn: 'Assigned on',
		completed: 'Completed',
		estimated_price: 'Estimated Price',
		bill_price: 'Bill Amount',
		status_text: 'Information about the current status',
		editStatusText: 'Edit status text',
		statusTextUpdated: 'The status text has been updated.',
		confirmEmptyStatusText:
			'The status text is empty. Do you really want to save the status without a status text?',
		confirmTakeOverStatusText:
			'Do you want to keep the previous status text for the new status?',
		contact_persons: 'Contact Persons',
		record: 'Record',
		taskUpdated: 'The craftsman task has been updated.',
		reopen: 'Reopen',
		confirmReopen:
			'Do you really want to reopen this task? It will become editable again afterwards.',
		taskReopened: 'The craftsman task has been reopened.',
		confirmDelete:
			'Do you really want to delete this craftsman task? Everything belonging to it will be gone. This cannot be undone.',
		taskDeleted: 'The craftsman task has been deleted.',
		invalidPrice: 'The estimated price must be a valid amount (e.g. 1250,00).',
		detail: {
			taskData: 'Task data',
			editModeHint:
				'Edit mode — changes are only applied after clicking “Save”.',
			billPricePending: 'not yet available',
			today: 'today',
			contactPerson: 'Contact person',
			noCraftsman: 'No craftsman assigned',
			sections: {
				order: 'Task',
				assignment: 'Assignment',
				amounts: 'Amounts',
				dates: 'Dates',
			},
		},
		statusTexts: {
			title: 'Status texts',
			open: 'All status texts',
			currentStatus: 'Current status',
			empty: 'No status text stored',
			noStatuses: 'No statuses are configured.',
			explainer:
				'Every status keeps its own status text. Nothing is lost when the status changes — texts of previous statuses stay stored and remain visible here.',
		},
		persons: 'Involved persons',
		personType: 'Type',
		personSourceBuilding: 'Building',
		personSourceUnit: 'Unit',
		personSourceAll: 'All persons',
		personsLink: 'Link person',
		removePersonLabel: 'Remove link to {name}',
		removePersonAction: 'Remove',
		personsLinked: 'Linked persons',
		personsEmpty: 'No persons linked yet.',
		personsSummary:
			'No person linked | 1 person linked | {count} persons linked',
		personPreselected: 'Only active person of the unit preselected',
		personAlreadyLinked: 'This person is already linked',
		personDuplicate: 'This person is already linked with type "{type}".',
		personAddedAlsoAs:
			'The person was linked. Note: they were already linked as "{type}".',
		personAdded: 'The person has been linked.',
		personAddFailed: 'The person could not be linked.',
		personRemoved: 'The person link has been removed.',
		confirmRemovePerson: 'Do you really want to remove the link to {name}?',
		noContactData: 'No contact data available',
		uploadDocuments: 'Upload documents',
		linkDocument: 'Link document',
		linkDocumentHint:
			'Select an existing document. The associated document folder including all contained files will be linked.',
		linkDocumentBuildingSource: 'Load building documents',
		linkDocumentUnitSource: 'Load unit documents',
		unlinkDocuments: 'Remove link',
		confirmUnlinkDocuments:
			'Do you really want to remove the link of the selected documents? The files themselves are kept; the entire associated document folder is unlinked.',
		filterByLinkedPerson: 'Linked person',
		documentLinked: 'The document has been linked.',
		documentUnlinked: 'The document link has been removed.',
		isUpdated: 'is updated',
		total_amount: '@:component.invoice.total_amount',
		activityTab: {
			tabLabel: 'History',
			empty: 'No changes have been logged for this craftsman task yet. Once someone saves an update, it will appear here.',
		},
		directMail: {
			action: 'Email participants',
			title: 'Email participants',
			to: 'To',
			cc: 'CC',
			bcc: 'BCC',
			template: 'Template',
			templateHint:
				'Select a template to prefill subject and body. Both fields remain freely editable afterwards.',
			subject: '@:common.subject',
			body: 'Message',
			send: '@:common.send',
			noEmail: 'No email address on file',
			freeEmailHint: 'Enter another email address and confirm with Enter',
			invalidEmail: '"{value}" is not a valid email address.',
			recipientRequired: 'Please select at least one recipient in the "To" field.',
			subjectRequired: 'Please enter a subject.',
			bodyRequired: 'Please enter a message.',
			missingPlaceholders: 'No values are available for the following fields: {fields}',
			confirmOverwriteTemplate:
				'Changing the template will discard your edits to subject and body. Do you want to continue?',
			confirmDiscard:
				'There are unsaved changes. Do you really want to close the dialog?',
			emailSent: 'The email has been sent.',
			sendFailed: 'The email could not be sent.',
			previewFailed: 'The preview could not be loaded.',
			contactOf: 'Contact person of {name}',
			context: {
				taskLabel: 'Task no. {number}',
			},
			attachments: {
				show: 'Add attachments',
				hide: 'Hide attachments',
				title: 'Attachments',
				none: 'No attachments',
				upload: 'Select files',
				existing: 'Attach linked documents',
				noDocuments: 'No documents are linked to this task.',
				untitledDocument: 'Untitled document',
				totalSize: 'Attachments total: {size}',
			},
			loadingTemplates: 'Loading templates…',
			loadingPreview: 'Loading preview…',
			footer: {
				recipients: 'Recipient | Recipients',
				attachments: 'Attachment | Attachments',
			},
		},
	},
}
